import Component from '@glimmer/component';

import { BadgeHighlight } from 'design-system-kit';

export default class OnboardingChoiceCardComponent extends Component {
  badgeHighlight = BadgeHighlight;
}
